import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Container from "./Container";
import { switchLanguage, toggleCollapsedNav } from "actions/Setting";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { moreAction: false };
  }

  render() {
    const { navigationStyle, horizontalNavPosition } = this.props;

    return (
      <Container
        navigationStyle={navigationStyle}
        horizontalNavPosition={horizontalNavPosition}
      />
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const {
    drawerType,
    locale,
    navigationStyle,
    horizontalNavPosition,
  } = settings;
  return { drawerType, locale, navigationStyle, horizontalNavPosition };
};

export default withRouter(
  connect(mapStateToProps, { toggleCollapsedNav, switchLanguage })(Header)
);
